import { Loading, useBreakpoint } from '@moda/om';
import React from 'react';
import loadable from '@loadable/component';

const CuratedLooksNotificationsComponentForDesktop = loadable(
  () => import('./CuratedLooksNotificationsComponentForDesktop'),
  {
    fallback: <Loading />
  }
);

const CuratedLooksNotificationsComponentForMobile = loadable(
  () => import('./CuratedLooksNotificationsComponentForMobile'),
  {
    fallback: <Loading />
  }
);

export const CuratedLooksNotificationsComponent: React.FC<{
  children?: React.ReactNode;
}> = () => {
  const { matches: isDesktop } = useBreakpoint({ gt: 'sm' });

  if (isDesktop) {
    return <CuratedLooksNotificationsComponentForDesktop />;
  }

  return <CuratedLooksNotificationsComponentForMobile />;
};
